import { useEffect, useState } from "react"
import ItemPersonDTO from "../../DTO/ItemPersonDTO"
import { Button } from "@mui/material"

export default function MailtoButton(props: {
  items: ItemPersonDTO[],
  whitelist?: number[],
  className?: string,
}) {
  const [emailList, setEmailList] = useState<string[]>([])

  useEffect(() => {
    console.log('receive info', props.items, props.whitelist)
    if (props.whitelist !== undefined) {
      setEmailList(props.items.filter(item => (props.whitelist || []).includes(item.id)).map(item => item.email).filter(mail => mail))
    } else {
      setEmailList(props.items.map(item => item.email).filter(mail => mail))
    }
  }, [props.items, props.items.length, props.whitelist, props.whitelist?.length])
  return <Button
      variant="outlined"
      onClick={() => window.open(`mailto:?bcc=${emailList.join(',')}`, '_self')}
    >
      Email {emailList.length}
    </Button>
}

